<template>
    <!-- 提前赎货 -->
    <div class="templete">
        <div class="search_box search_box_f clearfix">
            <div class="search_time search_inputBox">
                <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始日期"></el-date-picker>
                ~
                <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
            </div>
            <el-input class="search_input search_inputBox" v-model="params.redeem_order_sn" placeholder="赎货单号"></el-input>
            <el-select class="search_select search_inputBox" multiple collapse-tags v-model="params.issuing_id" placeholder="开证公司" @visible-change="getSelectList('advissuing')">
                <el-option v-for="(list,index) in selectMap.advissuing" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" multiple collapse-tags v-model="params.status" placeholder="赎货状态" @visible-change="getSelectList('advstatus')">
                <el-option v-for="(list,index) in selectMap.advstatus" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <!-- <el-select class="search_select search_inputBox" multiple collapse-tags v-model="params.sales_status" placeholder="订单状态" @visible-change="getSelectList('redeemsales')">
                <el-option v-for="(list,index) in selectMap.redeemsales" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-input class="search_input search_inputBox" v-model="params.contract_no" placeholder="关联销售单"></el-input> -->
            <div class="searchBtnList clearfix">
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
            </div>
             <div class="execlInsert execlInsertHasFilter clearfix">
                <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                <span class="excel_btn" @click="excelExport"><i class="excel-icon"></i>excel导出</span>
            </div>
        </div>
        <div class="btnBox">
            <div class="payBtnDiv" >
                <el-button  type="info" class="publicBtn" style="margin-right: 10px;" @click="openDvance">提前赎货</el-button>
                <!-- <el-button  type="info" class="publicBtn" @click="batchShowPayMoney(1)">付款</el-button> -->
            </div>
            <div class="balanceDiv">
                <el-radio-group v-model="currentPayRadio" class="banCheckboxGroup">
                    <div class="balanceItem" size="medium"
                                    v-for="(it,i) in  balance" :key="'ck_'+i" :label="it">
                        <i class="iconfont icon-hetong-3 balanceIcon"></i>
                        <!-- <img class="balanceIcon" src="/icon/finance.png"> -->
                        <span style="text-decoration: underline;cursor: pointer;position: relative;top: 5px;" @click.prevent="toShortDetail(it)">{{it.short_name}}（赎货余额）</span>
                        <span style="position: relative;top: 5px;">：</span>
                        <span class="underCanClick" style="text-decoration: underline;cursor: pointer;position: relative;top: 5px;" @click.prevent="showBalanceDialog(it)">{{it.balance}}m³</span>
                    </div>
                </el-radio-group>
            </div>
        </div>
        <div class="tableBox">
            <tabletem :isShowIndex="true" :isSetCol="true" scene="redeem.advance.list" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @rowClick="rowClick" @getTableDelete="getTableDelete"></tabletem>
        </div>
        <div class="totalCal">
            <div class="totalNumber">合计：</div>
            <div class="totalNumber">赎货单:{{tot.redeem_count}}单</div>
            <div class="totalNumber">未付金额:{{tot.unpay_amount}}</div>
        </div>
        <div class="pageBox">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <!-- 新增付款单 dialog START -->
        <el-dialog v-dialog-drag :title="form_params.redeem_category==1?'赎货付款':'合同结算付款'" :visible.sync="payMoneyDialog" class="eldialog no_print eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="add_params" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="融资合同：" required>
                        <el-select v-model="add_params.purchase_id" placeholder=""  disabled  @visible-change="getSelectList('pledgePurchase')">
                            <el-option v-for="item in selectMap.pledgePurchase" :key="item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="融资提单：" v-if="form_params.redeem_category==1" required>
                        <el-select v-model="add_params.finance_order_id" placeholder="" disabled >
                            <el-option v-for="item in pledgeOrderList" :key="item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="交易日期：" required>
                        <el-date-picker v-model="trading_time" type="date" ></el-date-picker>
                    </el-form-item>
                   <el-form-item label="我方账户：" required>
                        <el-select v-model="add_params.account_id" placeholder="" @visible-change="getSelectList('account')">
                            <el-option v-for="item in selectMap.account" :key="item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="收款方：" prop="receipt_name" required>
                        <el-input v-model="add_params.receipt_name" disabled></el-input>
                    </el-form-item>
                    <el-form-item  label="流水类型：" prop="bill_type_text" required>
                        <el-input v-model="add_params.bill_type_text" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="交易方式：" required>
                        <el-select v-model="add_params.payment_type_id" placeholder="" @visible-change="getSelectList('paymentType')">
                            <el-option v-for="item in selectMap.paymentType" :key="item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="科目名称：" prop="course_name" required>
                        <el-input  v-model="add_params.course_name" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="付款金额：" required>
                        <el-input v-model="add_params.pay_amount" @input.native="changeRate($event,add_params.amount)"  placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="备注信息：">
                        <el-input v-model="add_params.remark" placeholder=""></el-input>
                    </el-form-item>
                    <!-- <el-form-item prop="pay_file" style="height: 35px" >
                                     <span slot="label"><span>付款凭证：</span>
                                </span>
                        <ym-upload ref="payUp" :init-list="fileListShow" :disabled="false" :form-param.sync="add_params.pay_file"></ym-upload>
                    </el-form-item> -->
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="payMoneyDialog=!payMoneyDialog">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="addOrderSheetBack(type)">{{form_params.redeem_category==1?'付款':'结算付款'}}</el-button>
            </div>
        </el-dialog>
        <!-- 新建提前赎货弹框 -->
        <el-dialog v-dialog-drag :visible.sync="addDvanceDialog" class="eldialog eldialogC threeLabel no_print eldialogWidth" :modal="false" title="新建提前赎货单" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form class="clearfix dialogFormB dialogForm" :model="form_params" ref="saleorderA">
                    <div class="elFormBox">
                        <el-form-item  label="开证公司：" prop="issuing_id">
                            <el-select class="search_select search_inputBox"  v-model="form_params.issuing_id" placeholder="开证公司" @visible-change="getSelectList('inventoryissuing')">
                                <el-option v-for="(list,index) in selectMap.inventoryissuing" :key="index" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="elFormBox"> 
                        <!-- :disabled="!saleOrderIsEdit" -->
                        <el-form-item  label="赎货日期：" prop="redeem_date">
                            <el-date-picker  v-model="form_params.redeem_date" type="date" size="mini"></el-date-picker>
                        </el-form-item>
                    </div>
                    <div class="elFormBox" style="padding-left: 20px;">
                        <el-form-item  label="赎货类型：">
                            <el-select class="twoSelect" @change="chooseRedeem" v-model="form_params.redeem_category" >
                                <el-option  value="1" :label="'赎融资提单'"></el-option>
                                <el-option  value="2" :label="'赎融资合同'"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="elFormBox" style="padding-left: 20px;">
                        <el-form-item  label="保证金抵扣：">
                            <el-input v-model="form_params.is_deposit_text" disabled></el-input>
                            <!-- <el-select class="twoSelect" v-model="form_params.is_deposit" disabled>
                                <el-option  value="1" :label="'是'"></el-option>
                                <el-option  value="0" :label="'否'"></el-option>
                            </el-select> -->
                        </el-form-item>
                    </div>
                    <!-- <div class="elFormBox">
                        <el-form-item  label="赎货人：" prop="salesman_id">
                            <el-select v-model="form_params.salesman_id" @change="saleChange" @visible-change="getSelectList('user',$event)">
                                <el-option v-for="list in selectMap.user" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                    </div> -->
                    
                    <div class="globalFilterBtn" v-if="module.indexOf(',system-column-set,')!=-1" @click="filterDialogVisibleB=!filterDialogVisibleB"></div>
                </el-form>
                <div class="dialogFlow">
                    <div class="editBox">
                        <div class="editList">
                            <el-table :data="listDetail" :summary-method="getTableSummaries" ref="outBoundDetailTable" border show-summary stripe highlight-current-row size="mini" height="100%" @selection-change="selectionDetailChange" @row-click="toggleSelection" @header-dragend="headDrog">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column label="操作"  width="80">
                                    <template slot-scope="scope">
                                        <div class="icon_wrap">
                                            <i class="operation_add" @click="addGoods" title="添加"></i>
                                            <i class="operation_delete" @click="listDetailDelete(scope.$index)" title="删除"></i>
                                        </div>
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column type="selection" :selectable="checkSelectable" width="50"></el-table-column> -->
                                <template v-for="(item) in filters">
                                    <el-table-column :prop="item.field" v-if="item.show && billColumn.includes(item.field)" :key="item.field" :label="item.name"
                                                :sortable="false"
                                                :width="item.width && item.width>0 ?item.width:80+ 'px'"
                                                align="left"
                                                show-overflow-tooltip
                                            >
                                        <template slot-scope="scope">
                                            <div v-if="item.field == 'sales_width_total'">
                                                <span @click="widthList = scope.row.sales_width;dialogVisibleWidth=true;" style="text-decoration:underline;cursor:pointer;">
                                                    {{ scope.row.sales_width_total }}
                                                </span>
                                            </div>
                                            <span v-else>
                                                {{ scope.row[item.field] }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                            <!-- <el-table :data="listDetail"  border show-summary stripe highlight-current-row size="mini" height="100%" @selection-change="selectionDetailChange" @row-click="toggleSelection">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column label="操作"  width="80">
                                    <template slot-scope="scope">
                                        <div class="icon_wrap">
                                            <i class="operation_add" @click="addGoods" title="添加"></i>
                                            <i class="operation_delete" @click="listDetailDelete(scope.$index)" title="删除"></i>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="融资单号" width="135" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.finance_order_sn }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="捆包号" width="100" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.bale_no }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品名" width="90" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.breed }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品牌" width="100" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.brand}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="等级" width="90" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.grade}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="规格" width="120" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.spec}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="片数" width="90" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.pieces}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="方数" prop="original_cube" width="110" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.original_cube}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="赎货单价" width="100" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span  style="text-decoration:underline;cursor:pointer;"> {{ scope.row.redeem_price}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="赎货金额" prop="redeem_amount" width="100" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.redeem_amount}}
                                    </template>
                                </el-table-column>
                            </el-table> -->
                        </div>
                    </div>
                </div>
                <div class="editBtnList clearfix">
                    <!-- <div class="balanceDiv">
                        <img class="balanceIcon" src="/icon/finance.png" style="position: relative;top: 5px;margin-right: 10px;">
                        <span style="font-weight: 700;">赎货余额({{form_params.provider_name}})：{{form_params.balance}}</span>
                    </div> -->
                    <div class="editBtn">
                        <!-- <el-button class="funcPublicBtn" @click="print">打印</el-button> -->
                        <!-- <el-button class="funcPublicBtn" v-if="module.indexOf(',warehouse-doc-out-export,')!=-1" @click="exportExcel">导出</el-button> -->
                        <el-button class="funcPublicBtn funcPublicBtnChecked" @click="saveData()">保存</el-button> 
                    </div>
                </div>
                
            </div>
        </el-dialog>
         <!-- dialog 提前赎货单查看  START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisible" class="eldialog eldialogC threeLabel no_print eldialogWidth" :modal="false" :title="'提前赎货单('+form_params.redeem_order_sn+')'" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form class="clearfix dialogFormB dialogForm" :model="form_params" ref="saleorderA">
                    <div class="elFormBox">
                        <el-form-item  label="开证公司：" prop="issuing">
                            <el-input v-model="form_params.issuing" disabled></el-input>
                        </el-form-item>
                    </div>
                    <div class="elFormBox"> 
                        <el-form-item  label="赎货日期：" prop="redeem_date">
                            <el-date-picker v-model="form_params.redeem_date" disabled type="date" :readonly="true" placeholder="" size="mini"></el-date-picker>
                        </el-form-item>
                    </div>
                    <div class="elFormBox">
                        <el-form-item  label="赎货类型：" prop="redeem_category_text">
                            <el-input v-model="form_params.redeem_category_text" disabled></el-input>
                        </el-form-item>
                    </div> 
                    <div class="elFormBox">
                        <el-form-item  label="保证金抵扣：" prop="is_deposit_text">
                            <el-input v-model="form_params.is_deposit_text" disabled></el-input>
                        </el-form-item>
                    </div> 
                    <!-- <div class="elFormBox">
                        <el-form-item  label="采购合同号：" prop="sales_time">
                            <el-input v-model="form_params.contract_no" disabled></el-input>
                        </el-form-item>
                    </div>
                    <div class="elFormBox">
                        <el-form-item  label="赎货人：" prop="sales_time">
                            <el-input v-model="form_params.redeemer_name" disabled></el-input>
                        </el-form-item>
                    </div> -->
                    <div class="globalFilterBtn" v-if="module.indexOf(',system-column-set,')!=-1" @click="filterDialogVisibleB=!filterDialogVisibleB"></div>
                </el-form>
                <div class="dialogFlow">
                    <div class="editBox">
                        <div class="editList">
                            <el-table :data="listDetail" :summary-method="getTableSummaries" ref="outBoundDetailTable" border show-summary stripe highlight-current-row size="mini" height="100%" @selection-change="selectionDetailChange" @row-click="toggleSelection" @header-dragend="headDrog">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <!-- <el-table-column type="selection" :selectable="checkSelectable" width="50"></el-table-column> -->
                                <template v-for="(item) in filters">
                                    <el-table-column :prop="item.field" v-if="item.show && billColumn.includes(item.field)" :key="item.field" :label="item.name"
                                                :sortable="false"
                                                :width="item.width && item.width>0 ?item.width:80+ 'px'"
                                                align="left"
                                                show-overflow-tooltip
                                            >
                                        <template slot-scope="scope">
                                            <div v-if="item.field == 'sales_width_total'">
                                                <span @click="widthList = scope.row.sales_width;dialogVisibleWidth=true;" style="text-decoration:underline;cursor:pointer;">
                                                    {{ scope.row.sales_width_total }}
                                                </span>
                                            </div>
                                            <span v-else>
                                                {{ scope.row[item.field] }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                            <!-- <el-table :data="listDetail" ref="outBoundDetailTable" border show-summary stripe highlight-current-row size="mini" height="100%" @selection-change="selectionDetailChange" @row-click="toggleSelection">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column label="融资单号" width="135" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.finance_order_sn }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="捆包号" width="100" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.bale_no }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品名" width="90" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.breed }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品牌" width="100" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.brand}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="等级" width="90" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.grade}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="规格" width="120" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.spec}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="片数" width="90" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.pieces}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="方数" prop="original_cube" width="110" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.original_cube}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="赎货单价" width="100" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span  style="text-decoration:underline;cursor:pointer;" @click="costLogDetailOpen"> {{ scope.row.redeem_price}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="赎货金额" prop="redeem_amount" width="100" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.redeem_amount}}
                                    </template>
                                </el-table-column>
                            </el-table> -->
                        </div>
                    </div>
                </div>
                <div class="totalCal" v-if="form_params.redeem_category==1"> 
                    <div class="totalName">合计：</div>
                    <div class="totalNumber" v-if="form_paramstot.redeem_amount!=0">赎货金额:{{form_paramstot.redeem_amount}}</div>  
                    <!-- <div class="totalNumber" >融资费用:{{form_paramstot.redeem_fee}}</div>       -->
                    <div class="totalNumber" v-if="form_paramstot.payable_amount!=0">应付金额:{{form_paramstot.payable_amount}}</div>
                </div>
                <div class="totalCal" v-else>
                    <div class="totalName">合计：</div>
                    <div class="totalNumber" >合同融资总额：{{form_paramstot.redeem_amount}}</div>
                    <div class="totalNumber" >计息费用：{{form_paramstot.interest_amount}}</div>
                    <div class="totalNumber" >实付总额：{{form_paramstot.pay_amount}}</div>
                    <div class="totalNumber" >抵扣保证金：{{form_paramstot.deposit}}</div>
                    <div class="totalNumber" >{{form_paramstot.payable_amount>=0?'赎货应付':'合同余额'}}：<span class="redColor">{{form_paramstot.payable_amount}}</span></div>
                    <!-- <div class="totalNumber" >赎货金额:{{form_paramstot.redeem_amount}}</div> 
                    <div class="totalNumber" >融资利息:{{form_paramstot.interest_amount}}</div>      
                    <div class="totalNumber" v-if="form_paramstot.storage_amount!=0">融资仓储费:{{form_paramstot.storage_amount}}</div>
                    <div class="totalNumber" v-if="form_paramstot.clauses_amount!=0">押汇利息:{{form_paramstot.clauses_amount}}</div>
                    <div class="totalNumber" >应付金额:{{form_paramstot.payable_amount}}</div>
                    <div class="totalNumber" >抵扣保证金:{{form_paramstot.deposit}}</div>       -->
                </div>
                <div class="editPersonBox clearfix">
                    
                </div>
                <div>
                </div>
                <div class="editBtnList clearfix">
                    <div class="balanceDiv">
                        <!-- <img class="balanceIcon" src="/icon/finance.png" style="position: relative;top: 5px;margin-right: 10px;">
                        <span style="font-weight: 700;">赎货余额({{issuing_balance.short_name}})：{{issuing_balance.balance}}</span> -->
                        <div class="grayFont">  
                            <span  v-if="form_params.redeem_category==1">融资提单号：{{form_params.finance_order_sn}}</span>
                            <span  v-else>融资合同号：{{form_params.contract_no}}</span>
                            <span class="paddLeft">赎货人：{{form_params.redeemer_name}}</span>
                        </div>
                    </div>
                    <div class="editBtn">
                        <!-- <el-button class="funcPublicBtn" @click="print">打印</el-button> -->
                        <el-button class="funcPublicBtn" v-if="module.indexOf(',warehouse-doc-out-export,')!=-1" @click="exportExcel">导出</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" @click="openaddDialogVisibleBack(2)">赎货付款</el-button> 
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- dialog END -->
        <!--选择库存START-->
        <el-dialog v-dialog-drag  :visible.sync="dialogVisibleStock" class="eldialog eldialogStock" width="1250px" :modal="false" title="选择融资库存" custom-class="full_dialog">
            <finceanStock ref="selectstock" :ap-params="apParams" @cancel="dialogVisibleStock=!dialogVisibleStock" @selectData="selectData" @selectAndOut="selectAndOut"></finceanStock>
        </el-dialog>
        <!--选择库存END-->
        <!-- 融资成本单价 START -->
        <el-dialog v-dialog-drag :visible.sync="costLogDetailDialog" class="eldialog"
                width="530px" :modal="false" :title="'融资成本单价'" custom-class="full_dialog">
            <div class="tableBox" style="max-height: 200px">
            <tabletem :isShowIndex="true" :is-hide-checkout="false" :is-align-center="true"  :tablecol="costLogDetailTableCol" :tabledata="costLogDetailList">
            </tabletem>
            </div>
            <div class="costLogBottomBtn" style="padding: 30px 0 0;">
                <el-button type="primary" @click="costLogDetailDialog=false">我知道了</el-button>
            </div>
        </el-dialog>
        <!-- 融资成本单价 END -->
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" :isGlobal="isGlobal" scene="redeem.advance.list" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!-- 单据字段过滤 START -->
        <filter-fields :tableData="filter" :isGlobal="isGlobal" scene="redeem.advance.column" :filterDialogVisible="filterDialogVisibleB" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisibleB = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!-- 货权明细 START -->
        <el-dialog v-dialog-drag :visible.sync="cargodetailsDialog" class="eldialog specTable" width="500px" :modal="false" title="查看货权" custom-class="full_dialog">
             <!-- :summary-method="getTableSummaries"  show-summary  -->
             <div class="search_box search_box_c clearfix no_print">
                <el-select class="search_select search_inputBox" multiple collapse-tags v-model="cargo.issuing_id" placeholder="开证公司" @visible-change="getSelectList('advissuing')">
                    <el-option v-for="(list,index) in selectMap.advissuing" :key="index" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-model="cargo.order_sn" placeholder="融资提单号"></el-input>
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="reseCargot">重置</div>
                    <el-button  class="publicBtn" @click="getCargoDetail()">查询</el-button>
                </div>
            </div>
            <el-table :data="cargoDetail" border stripe highlight-current-row  size="mini"  style="min-height:200px;max-height:400px;margin-top: 5px;">
                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                <el-table-column label="开证公司" prop="issuing" show-overflow-tooltip></el-table-column>
                <el-table-column label="融资提单" prop="order_sn" show-overflow-tooltip></el-table-column>
                <el-table-column label="监管方数" prop="supervise_cube" show-overflow-tooltip></el-table-column>
                <el-table-column label="可发方数" prop="property_cube" show-overflow-tooltip></el-table-column>
            </el-table>
            <div style="height: 34px;text-align: left;">
                <div style="padding: 5px;font-size: 15px;">
                    <!-- <span style="padding-left: 25px;">合计：{{cubeTotal.cube}}m³</span>
                    <span style="padding-left: 25px;">外币金额：{{cubeTotal.foreign_amount}}</span>   -->
                </div>
            </div>
       </el-dialog>
        <!-- 货权明细 END -->
    </div>
</template>
<script>
    import bus from "../../../../eventBus";
    import tabletem from '../../../../components/table.vue';
    import finceanStock from '../components/finstock.vue';
    import pagination from '../../../../components/pagination.vue';
    const initDetailItem = {
       
        };
    const initDetailList = [initDetailItem];
    const initFormParams={
        salesman_id: localStorage.dw_erp_user_id ? parseInt(localStorage.dw_erp_user_id) : "",
        redeem_date:new Date(),
        form_params:"",
        issuing_id:"",
        redeem_category:'',
        is_deposit_text:''
    };
    const initPayForm={
        issuing_id:"",
        trading_time:"",
        pay_amount:"",
        account_id:"",
        payment_type_id:"",
        remark:"",
        // pay_file: [],
        course_name:"赎货付款",
        bill_type_text:"支出",
    };
    export default {
        data(){
            return {
                module: localStorage.dw_erp_power_code,
                start_time:"",
                end_time:"",
                params:{
                    start_time:"",
                    end_time:"",
                    redeem_order_sn:""
                },
                last_page:1,
                total:0,
                tot:{},
                fields:"",
                filter:"",
                filters: [],
                filterDialogVisible:false,
                filterDialogVisibleB:false,
                isGlobal:false,
                tableLoading:false,
                selectRow:[],
                tableCol:[
                    {colName:"赎货单号",colKey:"redeem_order_sn",colWidth:80,isSetWidth:true,isCanClick:true,isShow:true,},
                    {colName:"赎货日期",colKey:"redeem_date",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"赎货状态",colKey:"status_text",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,},
                    {colName:"销售状态",colKey:"sales_status_text",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"开证公司",colKey:"issuing",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"应付金额",colKey:"redeem_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"已付金额",colKey:"pay_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"未付金额",colKey:"unpay_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,},
                    {colName:"付款人",colKey:"payer_name",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"关联销售单",colKey:"order_sn",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注",colKey:"remark",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"赎货类型",colKey:"redeem_category_text",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"赎货人",colKey:"creator_name",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true}
                ],
                list:[],
                selectMap:{
                    advissuing:[],
                    redeemstatus:[],
                    redeemsales:[],
                    paymentType:[],
                    account:[],
                    user:[],
                    inventoryissuing:[],
                },
                selectMapF:{},
                balance: [],//余额
                currentPayRadio:'',
                payMoneyDialog:false,
                add_params:this.$cloneJson(initPayForm),
                fileListShow:[],
                apParams:{},
                trading_time:new Date(),
                dialogVisible:false,
                form_params: this.$cloneJson(initFormParams),
                form_paramstot:{},
                issuing_balance:{},
                listDetail: this.$cloneJson(initDetailList),
                listDetail_id:[],
                addDvanceDialog:false,//提前赎货弹框
                dialogVisibleStock: false,
                costLogDetailDialog:false,//融资成本单价
                costLogDetailList:[],
                costLogDetailTableCol:[
                    {colName:"成本日期",colKey:"fee_date",isDate:true,},
                    {colName:"成本类型",colKey:"fee_name"},
                    {colName:"成本单价",colKey:"amount"},
                    {colName:"操作人",colKey:"creator_name"},
                ],
                pledgeOrderList:[],
                cargodetailsDialog:false,
                cargoDetail:[],
                cargo:{
                    order_sn:'',
                    issuing_id:''
                }
            }
        },
        created(){
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList();
            this.getSelectList('user');
            this.getSelectList('account');
            this.getSelectList('paymentType');
            this.getSelectList('advstatus');
            this.getSelectList('pledgePurchase');
        },
        methods:{
            headDrog(newWidth, oldWidth, column) {
                this.filters.forEach((item) => {
                    if (column.property == item.colKey) {
                        item.colWidth = newWidth;
                    }
                });
                let obj = {};
                obj.width = parseInt(newWidth);
                obj.name = column.property;
                let emit = ("changeHeadWidth" + this.scene).replace(/\./g, "");
                bus.$emit(emit, obj);
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            getPledgeOrderList(purchase_id){
                this.postFunc('/erp/pledge.order.option',{purchase_id:purchase_id},res=>{
                    this.pledgeOrderList = res.data.data
                })
            },
            getList(){
                this.tableLoading = true;
                this.params.start_time=this.formatTimeZero(this.start_time);
                this.params.end_time=this.formatTimeZero(this.end_time);
                this.$postColumnList("/erp/redeem.advance.list",this.params,res=>{
                    this.last_page=parseInt(res.data.data.data.last_page);
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.data.total);
                    this.balance = res.data.data.issuing_balance;
                    this.tot= res.data.data.total;
                    this.list=res.data.data.data.data;
                    let obj ={
                        sales_count:res.data.data.sales_count,
                        advance_count:res.data.data.advance_count
                    }
                    this.$emit('child-num',obj)
                    this.list.forEach((item,index)=>{
                        item.baseColor = "";
                        this.list[index].redeem_date = this.formatTime(item.redeem_date+"000")
                        if(item.status_text=='待付款'){
                            item.baseColor='red';
                        }
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="status_text"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                })
            },
            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            reset(){
                this.params=this.resetSearch(this.params)
                this.start_time="";
                this.end_time="";
                this.getList();
            },
            selectionDetailChange(row){
                this.selectionDetailRow=row;
            },
            toggleSelection(row) {
                if(row.isSelect==1){
                    this.$refs.outBoundDetailTable.toggleRowSelection(row);
                }else{
                    return false;
                }
            },
            getRow(row){
                this.selectRow=row;
            },
            changeRate(e,input){
                e.target.value=(e.target.value.match(new RegExp("^\\-?\\d*(\\.?\\d{0,2})","g"))[0]) || null
                let inputs=e.target.value;
                this.add_params.pay_amount=inputs;
            },
            openDvance(){
                this.addDvanceDialog= true;
                this.scene = 'redeem.advance.column';
                this.isGlobal = true;
                this.getBillColumn();
            },
            batchShowPayMoney(type) {
                this.type = type;
                let ts = this.selectRow;//表格的选中项
                let cr = this.currentPayRadio;
                if (ts.length > 0 && !cr) {
                    this.tip("表格内数据付款请进入详情页面操作","warning");
                    return;
                }
                if (!cr) {
                    this.tip("必须选择右侧一条付款项", "warning");
                    return;
                }
                this.add_params.issuing_id = cr.id;
                this.add_params.receipt_name = cr.name;
                this.payMoneyDialog = true;
            },
            //付款确定
            addOrderSheetBack(ty){
                this.add_params.trading_time = this.formatTimeZero(this.trading_time);
                this.add_params.pay_amount = Number(this.add_params.pay_amount);
                this.add_params.redeem_type = 2;
                if(this.form_params.redeem_category==2){
                    delete this.add_params.finance_order_id
                }
                if(ty==1){
                    this.postFuncLoading('/erp/redeem.payment',this.add_params,res=>{
                        this.tip('付款成功',"success");
                        this.getList();
                        this.payMoneyDialog = false;
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }else{
                    this.add_params.redeem_order_sn = this.form_params.order_sn;
                    this.add_params.redeem_order_id = this.form_params.id;
                    // this.add_params.issuing_id = this.form_params.issuing_balance.id;
                    this.postFuncLoading('/erp/redeem.payment',this.add_params,res=>{
                        this.tip('付款成功',"success");
                        this.payMoneyDialog = false;
                        this.dialogVisible = false;
                        this.getList();
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }
            },
            saleChange(){
                this.form_params.customer_id="";
            },
            payMoneyTop(){},
            listDetailDelete(index){
                this.listDetail.splice(index,1);
                if(this.listDetail.length<=0){
                    this.listDetail = this.$cloneJson(initDetailList);
                }
            },
            //选择库存信息
            selectData(row){
                let rowData = this.$cloneJson(row);
                rowData.forEach(item=>{
                    item.sales_cube_copy = item.sales_cube;
                    item.sales_cube_copy_reback = item.sales_cube;
                    item.discount_price = item.sales_price;
                    item.discount_price_copy = item.sales_price;
                })
                this.listDetailSet(rowData);
            },
            addGoods(){
                if (!this.form_params.issuing_id) {
                    this.tip('请选择开证公司', 'warning');
                    return false;
                }else if(!this.form_params.redeem_category) {
                    this.tip('请选择赎货类型', 'warning');
                    return false;
                }
                this.apParams = {
                    issuing_id: this.form_params.issuing_id,
                    redeem_category:this.form_params.redeem_category,
                };
                this.dialogVisibleStock = !this.dialogVisibleStock;
            }, 
            listDetailSet(row){
                if(row.length<1){
                    return;
                }
                let rows = this.$cloneJson(row);
                this.listDetail = rows;
            },
            // 选择赎货类型
            chooseRedeem(){
                if(this.form_params.redeem_category==1){
                    this.form_params.is_deposit_text = '否';
                }else if (this.form_params.redeem_category==2){
                    this.form_params.is_deposit_text = '是';
                }
            },
            //新建赎货单
            saveData(){
                let record={}
                record.details=this.listDetail.map(a=>{
                     return a.id;
                }) 
                record.issuing_id = this.form_params.issuing_id;
                record.redeem_date =this.formatTimeZero(this.form_params.redeem_date);
                record.redeem_category =Number(this.form_params.redeem_category);
                record.is_deposit_text = Number(this.form_params.is_deposit_text);
                this.postFunc('/erp/create.advance.redeem',record,res=>{
                    this.addDvanceDialog = false;
                    this.getList();
                    this.tip('创建成功','success')
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            selectAndOut(row){
                this.selectData(row);
                this.dialogVisibleStock = false;
            },
            //打开付款弹框
            openaddDialogVisibleBack(type){
                this.type = type;
                this.payMoneyDialog = true;
                 this.add_params.receipt_name = this.form_params.issuing;
                this.add_params.purchase_id = this.form_params.purchase_id;
                this.add_params.finance_order_id = this.form_params.finance_order_id;
            },
            filterConfirm(){
                if(this.isGlobal){
                    this.getBillColumn()
                }else{
                    this.getList()
                }
            },
            getBillColumn(){
                this.filters = [];
                this.postFunc("/erp/company.column.data",{scene:this.scene},response=>{
                    this.billColumn = ","+response.data.data.fields.join(",").toString()+",";
                    this.filter = response.data.data.columns;
                    this.filters = response.data.data.columns;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            rowClick(obj){
                this.scene = 'redeem.advance.column';
                this.isGlobal = true;
                this.getBillColumn();
                if(obj.name =='redeem_order_sn'){
                    this.dialogVisible = true;
                    this.postFunc('/erp/advance.redeem.info',{id:obj.id},res=>{
                        this.form_params = res.data.data;
                        this.form_paramstot = this.form_params.total;
                        this.issuing_balance = this.form_params.issuing_balance;
                        this.getPledgeOrderList(this.form_params.purchase_id);
                        this.add_params.pay_amount = this.form_paramstot.payable_amount<0?0:this.form_paramstot.payable_amount;
                        this.form_params.redeem_date = this.formatTime(this.form_params.redeem_date+"000");
                        this.listDetail = this.form_params.details;
                    })
                }
            },
            costLogDetailOpen(){
                this.postFunc('/erp/redeem.detail.costs',{id:this.form_params.id},res=>{
                        this.costLogDetailDialog = true;
                        let resD = res.data.data;
                        this.costLogDetailList = Array.isArray(resD) ? resD : [];
                    })
            },
            print(){

            },
            del(ids){
                this.confirmLog("是否确认删除?",()=>{
                    this.postFuncLoading("/erp/redeem.advance.delete",{id:ids.toString()},()=>{
                        this.tip('删除成功','success');
                        this.getList();
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                });
            },
            getTableDelete(id){
                this.del([id]);
            },
            //查看货权
            showBalanceDialog(item) {
                this.postFunc('/erp/pledge.goods.power',{issuing_id:[item.id]},res=>{
                    this.cargoDetail = res.data.data.list
                });
                this.cargo.issuing_id = [item.id];
                this.cargodetailsDialog = !this.cargodetailsDialog;
                //跳转到新页面
                // sessionStorage.removeItem("STORE_ISSUING_ID")
                // sessionStorage.setItem("STORE_ISSUING_ID",item.id)
                // this.$root.$children[0].$children[0].addTab({
                //     name: '赎货余额流水'+item.id,
                //     label: '赎货余额流水',
                //     content: 'bankRedeemFlow'
                // });
            },
            getCargoDetail(){
                 this.postFunc('/erp/pledge.goods.power',this.cargo,res=>{
                    this.cargoDetail = res.data.data.list
                })
            },
            reseCargot(){
                this.cargo=this.resetSearch(this.cargo);
                this.getCargoDetail();
            },
            //跳转赎货详情
            toShortDetail(item){
                sessionStorage.removeItem("STORE_ISSUING_ID")
                sessionStorage.setItem("STORE_ISSUING_ID",item.id)
                this.$root.$children[0].$children[0].removeNameTab('赎货详情'+item.id,
                {
                    name: '赎货详情'+item.id,
                    label: '赎货余额流水',
                    content: 'foreclosureDetail'
                });
            },
            //导出 提前赎货单
            exportExcel(){
                this.$exportExecl("/erp/advance.redeem.info.export","提前赎货单",{id:this.form_params.id})
            },
            excelExport(){
                this.$exportExecl("/erp/advance.redeem.export","提前赎货",this.params)
            },
            //合计
            getTableSummaries(params) {
                return this.$setSummaryFields(params, {
                    original_cube:4,
                    redeem_amount:2,
                },total=>{
                });
            },
        },
        components:{
            tabletem,
            finceanStock,
            pagination
        },
        watch:{
            'addDvanceDialog':function(val){
                if(!val){
                    this.form_params = this.$cloneJson(initFormParams);
                    this.listDetail=this.$cloneJson(initDetailList);
                }else{
                    this.form_params.redeem_date = new Date();
                }
            },
            'dialogVisible':function(val){
                if(!val){
                    this.form_params={};
                    this.listDetail=this.$cloneJson(initDetailList);
                }
            },
            "payMoneyDialog":function(val){
                if (!val) {
                    this.add_params = this.$cloneJson(initPayForm);
                    this.$refs['add_form'].resetFields();
                    this.fileListShow = [];
                }
            },
            "dialogVisibleStock":function(val){
                if(val){
                    this.$nextTick(()=>{
                        this.$refs['selectstock'].resetSelect();
                    })
                }
            }
        }
    }
</script>
<style  scoped lang="scss">
.btnBox{
    display: flex;
    .payBtnDiv{
        padding: 5px 20px 10px 0;display: inline-block;border-right: 2px solid #eee;
    }
    .balanceDiv{
        display: inline-block;
        .banCheckboxGroup{
            display: flex;
            margin-left: 20px;
        }
        .balanceItem{
            margin-left: 20px;
            line-height: 24px;
            font-weight: 600;
            font-size: 14px;
            margin-top: 7px;
            color: #606266;
            .balanceIcon{
                position: relative;
                top: 5px;
                margin-right: 1px;
                font-size: 24px;
                color: darkorange;
            }
            .balanceImg{
                width: 20px;
                height: 19px;
                position: relative;
                top: 5px;
                margin-right: 5px;
            }
            /*重写radio样式*/
            /deep/ .el-radio__inner{
                width: 20px;
                height: 20px;
                border-radius: 2px;
            }
            /deep/ .el-radio__input.is-checked .el-radio__inner:after{
                width: 6px;
                height: 13px;
                box-sizing: content-box;
                border: 1px solid #fff;
                border-left: 0;
                border-top: 0;
                left: 6px;
                position: absolute;
                border-radius: 2px;
                transform-origin: center;
                transform: rotate(45deg);
                background: none;
                top: 0;
            }
        }
    }
}
.editBtnList{padding:10px;
    .editTax{float: left;margin-right:20px;}
    .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
    .editTaxinput{float: left;width:100px;}
    .editBtn{float: right;}
}
</style>